module.exports = {
	"data": {
		"markdownRemark": {
			"id": "D:/projekty/Calipsy/src/pages/about.md absPath of file >>> MarkdownRemark",
			"frontmatter": {
				"title": "About",
				"banner": {
					"imageUrl": "/images/about/aboutbanner.jpg",
					"type": "small",
					"anchor": "center"
				}
			}
		}
	},
	"pathContext": {
		"path": "/about"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/about.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/about.json
// module chunks = 273950069227526